import HelmIcon from "../../assets/icons/HelmIcon"
import styles from "./styles.module.scss"

const NavigatorAvatar = () => {
  return (
    <div className={styles.linearGradient}>
      <HelmIcon width={20} height={20} color={"#0c0e1c"} />
    </div>
  )
}

export default NavigatorAvatar
